// Central environment config. All process.env access lives here.
// Call sites import named constants from this module — no direct process.env elsewhere.
// When migrating to Vite, replace process.env.REACT_APP_* with import.meta.env.VITE_* in this file only.

function required(key: string, value: string | undefined): string {
	if (!value) throw new Error(`Missing required environment variable: ${key}`);
	return value;
}

export const API_URL_REGIONS = required(
	"REACT_APP_API_URL_REGIONS",
	process.env.REACT_APP_API_URL_REGIONS
);

export const API_URL_COUNTRIES = required(
	"REACT_APP_API_URL_COUNTRIES",
	process.env.REACT_APP_API_URL_COUNTRIES
);

export const DATAWRAPPER_MEMBERS_MAP_URL =
	process.env.REACT_APP_DATAWRAPPER_MEMBERS_MAP_URL ??
	"https://datawrapper.dwcdn.net/b4bcL/1/";

export const REPORT_PDF_URL =
	process.env.REACT_APP_REPORT_PDF_URL ??
	"/files/pdf/applia-home-appliance-monitor-2025.pdf";

export const APPLIA_WEBSITE_URL =
	process.env.REACT_APP_APPLIA_WEBSITE_URL ??
	"https://www.applia-europe.eu/";

export const SOCIAL_LINKS = {
	linkedin:
		process.env.REACT_APP_SOCIAL_LINKEDIN_URL ??
		"https://www.linkedin.com/company/applia-europe/",
	x:
		process.env.REACT_APP_SOCIAL_X_URL ??
		"https://x.com/APPLiA_Europe",
	youtube:
		process.env.REACT_APP_SOCIAL_YOUTUBE_URL ??
		"https://www.youtube.com/channel/UCESWVGuceaVbTLEJN1yQKzw",
} as const;
